import React from 'react';
import { Input, Button, Select } from 'components';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants } from 'utils';
import { ConsultationPlanService } from 'services';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreateConsultation extends React.Component<Props> {

	state = {
		form: {
			name: '',
			price: '',
			quantity: '',
			audio: false,
			response_with_audio: false,
			instagram: false,
			whatsapp: false,
			facebook: false
		},
	}

	componentDidMount() {
		if (this.props.item) {
			const item: any = this.props.item;

			this.setState({
				form: {
					...this.state.form,
					name: item?.name || '',
					quantity: item?.quantity || '',
					price: item?.price || '',
					audio: item?.audio || false,
					response_with_audio: item?.response_with_audio || false,
					whatsapp: item?.whatsapp || false,
					instagram: item?.instagram || false,
					facebook: item?.facebook || false
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if (this.props.item) {
			await ConsultationPlanService.admin.save({
				...this.state.form,
				plan_id: this.props.item?.id
			});
			this.props.onClose();
			Globals.showSuccess("Se ha modificado el plan correctamente");
		}
		else {
			await ConsultationPlanService.admin.save({
				...this.state.form
			});
			this.props.onClose();
			Globals.showSuccess("Se ha registrado el plan correctamente");
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			page: 1,
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-plan">
				<form onSubmit={ this.submit }>
					<div className="row">
						<div className="col-md-12">
							<Input
								value={ this.state.form.name }
								name="name"
								placeholder="Nombre"
								label="Nombre del Plan"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								type="decimal"
								value={ this.state.form.price }
								name="price"
								placeholder="Precio"
								label="Precio del Plan (US$)"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<Input
								type="quantity"
								value={ this.state.form.quantity }
								name="quantity"
								placeholder="Cantidad"
								label="Cantidad de consultas"
								onChange={ (e: any) => this.change(e) } />
						</div>
						<div className="col-md-6">
							<div className="container-check" onClick={ () => this.setState({
								form: {
									...this.state.form,
									whatsapp: !this.state.form.whatsapp
								}
							}) }>
								<div className={ `check ${ this.state.form.whatsapp ? 'active' : '' }` }></div>
								<p>Whatsapp</p>
							</div>
						</div>
						<div className="col-md-6">
							<div className="container-check" onClick={ () => this.setState({
								form: {
									...this.state.form,
									audio: !this.state.form.audio,
									response_with_audio: this.state.form.audio ? false : this.state.form.response_with_audio
								}
							}) }>
								<div className={ `check ${ this.state.form.audio ? 'active' : '' }` }></div>
								<p>Intepretar audios (Solo Whatsapp)</p>
							</div>
							{
								this.state.form.audio && (
									<div className="container-check" style={{ marginTop: '5px', marginBottom: '10px' }} onClick={ () => this.setState({
										form: {
											...this.state.form,
											response_with_audio: !this.state.form.response_with_audio,
											audio: !this.state.form.response_with_audio ? true : this.state.form.audio
										}
									}) }>
										<div className={ `check ${ this.state.form.response_with_audio ? 'active' : '' }` }></div>
										<p>Responder con audio (Solo Whatsapp)</p>
									</div>
								)
							}
						</div>
						<div className="col-md-6">
							<div className="container-check" onClick={ () => this.setState({
								form: {
									...this.state.form,
									instagram: !this.state.form.instagram
								}
							}) }>
								<div className={ `check ${ this.state.form.instagram ? 'active' : '' }` }></div>
								<p>Instagram</p>
							</div>
						</div>
						<div className="col-md-6">
							<div className="container-check" onClick={ () => this.setState({
								form: {
									...this.state.form,
									facebook: !this.state.form.facebook
								}
							}) }>
								<div className={ `check ${ this.state.form.facebook ? 'active' : '' }` }></div>
								<p>Facebook</p>
							</div>
						</div>
					</div>
	      			<div className="text-center">
						<Button type="submit">
							Guardar
						</Button>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreateConsultation;